
<template>
  <v-container fluid class="pt-0">
    <v-row>
      <v-col
        cols="12"
        sm="10"
        md="6"
        lg="8"
        class="pa-0 d-flex justify-center align-center flex-column"
        :style="
          $vuetify.breakpoint.mdAndUp
            ? 'background-color: #28b2c1;  height: 80vh;'
            : 'background-color: #28b2c1;  height: 100vh;'
        "
      >
        <h1 class="white--text text-center" v-if="$vuetify.breakpoint.mdAndUp">
          ¿En qué consiste el diplomado en Salud Pública?
        </h1>
        <h1 class="white--text text-center px-10" v-else>
          Diplomado en Salud Pública
        </h1>
        <br />
        <br />
        <v-container class="text-justify mx-12 white--text text-center">
          <h4 class="px-10">
            El objetivo de este diplomado es desarrollar un Programa de Salud
            Integral, con la finalidad de prevenir, detectar, diagnosticar,
            tratar y controlar problemas de salud, desde su contexto
            profesional.
          </h4>
        </v-container>
        <v-btn
          @click="$router.push('/diplomado')"
          rounded
          class="link-button-animated grey--text text--darken-4 mt-2"
        >
          ¡Quiero informes!
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        sm="10"
        md="6"
        lg="4"
        class="pa-0"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        <v-img
          src="/diplomados/salud/contenido-salud.jpg"
          height="80vh"
          width="100%"
        ></v-img>
      </v-col>
    </v-row>

    <!-- Seccion de temario-->
    <v-row>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
        <v-card width="">
          <v-card-text>
            <h2 class="font-weight-bold ml-8 mb-2">
              Temario
              <br />
            </h2>
            <p class="ml-8 mb-2">
              En este diplomado se revisarán tres bloques temáticos:
            </p>
            <v-timeline align-top dense>
              <v-timeline-item
                v-for="message in messages"
                :key="message.time"
                :color="message.color"
                small
              >
                <div>
                  <div class="font-weight-normal">
                    <strong
                      ><span class="primary--text">{{ message.from }}</span>
                      {{ message.message }}
                    </strong>
                  </div>
                </div>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
        <v-card color="#129ba9" dark>
          <v-card-text>
            <div class="ml-8 mb-2">
              <h2>
                En cada bloque temático realizarás:
                <br />
                <br />
              </h2>
              <ul>
                <li>
                  Lectura de todo el material y utilizarás estrategias de
                  aprendizaje para comprender y analizar los contenidos.
                </li>
              </ul>
              <v-divider class="test mt-5 mb-5"></v-divider>
              <p>
                Con base en lo anterior construirás tus entregables, con las
                especificaciones que te señalen.
              </p>
              <v-divider class="test mt-5 mb-5"></v-divider>
              <p>
                Estas evidencias serán parte indispensable de tu proyecto
                integrador. Lo anterior implica que:
              </p>
              <h2 class="mb-4">
                Seas un estudiante autorregulado y autodirigido
              </h2>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="10" md="5" lg="5" class="pa-0">
        <v-img
          src="/diplomados/salud/modelo-salud.png"
          :height="$vuetify.breakpoint.mdAndUp ? '90vh' : '120vh'"
          width="100%"
        ></v-img>
      </v-col>
      <v-col
        cols="12"
        sm="10"
        md="7"
        lg="7"
        class="pa-0 d-flex justify-center align-center flex-column"
        :style="
          $vuetify.breakpoint.mdAndUp
            ? 'background-color: #28b2c1;  height: 90vh;'
            : 'background-color: #28b2c1;  height: 120vh;'
        "
      >
        <h1
          class="white--text text-center mx-10"
          style="color: rgba(255, 255, 255, 0.7) !important"
        >
          ¿Cómo acreditar el diplomado?
        </h1>
        <br />
        <h4 class="text-justify mx-10 white--text">
          Para fines de acreditación del diplomado, será necesario haber
          presentado todas las evidencias correspondientes según los bloques
          temáticos. Deberás demostrar un nivel de suficiencia en la aplicación
          de los conceptos implicados, según los requisitos dispuestos en
          términos de evaluación del aprendizaje, para la correcta realización
          del proyecto final.
        </h4>
        <br />
        <h4 class="text-justify mx-10 grey--text font-weight-light">
          *Cualquier evidencia de plagio será sancionado con la no acreditación.
        </h4>
        <br />
        <h4 class="text-justify mx-10 grey--text font-weight-light">
          *Los exámenes son sólo diagnósticos para identificar qué necesitas
          aprender y no son parte de la evaluación del diplomado.
        </h4>
        <v-btn
          @click="$router.push('/diplomado')"
          rounded
          class="link-button-animated grey--text text--darken-4 mt-2"
        >
          ¡Quiero informes!
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        :cols="$vuetify.breakpoint.mdAndUp ? 5 : 12"
        :class="
          $vuetify.breakpoint.mdAndUp
            ? 'px-6 py-6 d-flex justify-center align-center flex-column dark'
            : 'px-6 py-6 d-flex justify-center align-center flex-column dark  mt-5'
        "
        :style="
          $vuetify.breakpoint.mdAndUp
            ? 'background-color: #28b2c1;  height: 110vh;'
            : 'background-color: #28b2c1;  height: 170vh;'
        "
      >
        <br />
        <!-- <img
          src="/diplomados/ultimos.png"
          style="width: 22rem; padding-bottom: 5%"
        /> -->
        <h3
          class="text-justify white--text mb-5"
          style="color: rgba(255, 255, 255, 0.7) !important"
        >
          Fecha de inicio
        </h3>
        <h4 class="white--text">17 de Febrero 2025</h4>
        <h4 class="white--text">16 de Junio 2025</h4>
        <h4 class="white--text">17 de Noviembre 2025</h4>
        <h4 class="white--text">*Cupos Limitados</h4>
        <br />
        <h5 class="text-justify grey--text font-weight-light">
          *Duración de 4 meses
        </h5>
        <v-divider class="test mt-5 mb-5"></v-divider>

        <h3
          class="white--text mb-5"
          style="color: rgba(255, 255, 255, 0.7) !important"
        >
          Documentos para inscripción
        </h3>
        <ul class="white--text">
          <li><h4 class="white--text">Acta de nacimiento.</h4></li>
          <li><h4 class="white--text">CURP.</h4></li>
          <li><h4 class="white--text">Correo electrónico.</h4></li>
          <li><h4 class="white--text">Domicilio completo.</h4></li>
          <li><h4 class="white--text">Número de celular o teléfono.</h4></li>
          <li>
            <h4 class="white--text">
              Licenciatura terminada, universidad procedente o campus de egreso.
            </h4>
          </li>
          <li>
            <h4 class="white--text">
              Diplomado elegido, fecha de inicio del diplomado de su elección.
            </h4>
          </li>
          <li>
            <h4 class="white--text">
              Entrega de carta de autorización, carta de no adeudo académico y
              de finanzas.
            </h4>
            <h5 class="white--text font-weight-light">
              (con una antigüedad no mayor a 15 días naturales). <br />Solo
              alumnos de licenciatura de Vizcaya.
            </h5>
          </li>
        </ul>
        <v-divider class="test mt-5 mb-5"></v-divider>
        <h3
          class="text-justify white--text mb-5"
          style="color: rgba(255, 255, 255, 0.7) !important"
        >
          Realiza la inversión
        </h3>
        <h4 class="white--text">Costo total del Diplomado: $15,000</h4>
        <v-btn
          @click="$router.push('/diplomado')"
          rounded
          class="link-button-animated grey--text text--darken-4 mt-2"
        >
          ¡Quiero informes!
        </v-btn>
        <br />
      </v-col>

      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 7 : 12" class="pa-0">
        <v-img
          src="/diplomados/salud/Portada-salud.jpg"
          height="110vh"
          width="100%"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.ligthBlue {
  background-color: #5ecbd6;
}
.ligthBlueText {
  color: #5ecbd6;
}
.ext-container {
  background-image: url("/images/imagenes/campo-accion.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 5;
}
.test {
  border-width: 1px !important;
  border-color: white !important;
  width: 100%;
}
</style>
<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
  components: {},
  mounted() {},
  data: () => ({
    messages: [
      {
        from: "1. ",
        message: `Salud Pública, donde comprenderás la estructura y organización del Sistema Nacional de Salud, sus planes y programas.`,
        color: "amber",
      },
      {
        from: "2. ",
        message:
          "Epidemiología, dónde analizarás la importancia de la epidemiología en el proceso de salud-enfermedad y su vinculación con la salud pública.",
        color: "orange",
      },
      {
        from: "3. ",
        message:
          "Modelos y programas de atención en salud dónde diseñarás un programa de atención en salud, atendiendo tu área profesional. ",
        color: "orange darken-4",
      },
    ],
  }),
  computed: {
    ...mapState({}),
  },
  methods: {},
  watch: {},
};
</script>
